package org.example.project.settings

import org.jetbrains.compose.web.css.*

// Inline-Style-Helfer für Stellen, die noch nicht auf LumaticaButton migriert wurden.
// Entspricht dem Action-Stil: kein Glow im Ruhezustand, weisser Glow nur beim Klick.

fun StyleScope.applyAppButtonChrome() {
    backgroundColor(Color.transparent)
    color(Color.white)
    property("border", "1px solid rgba(255,255,255,0.22)")
    borderRadius(8.px)
    fontSize(12.px)
    fontWeight("600")
    cursor("pointer")
    property("box-sizing", "border-box")
    property("box-shadow", "0 12px 28px rgba(0,0,0,0.24), 0 0 14px ${UISettings.accentRgba(0.08)}, inset 0 1px 0 rgba(255,255,255,0.10)")
    property("transition", "border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease, transform 0.12s ease")
}

fun StyleScope.applyAppButtonHoverChrome() {
    property("border-color", "rgba(255,255,255,0.36)")
    property("box-shadow", "0 14px 32px rgba(0,0,0,0.30), 0 0 18px rgba(255,255,255,0.10), 0 0 16px ${UISettings.accentRgba(0.10)}, inset 0 1px 0 rgba(255,255,255,0.14)")
}

fun StyleScope.applyAppButtonActiveChrome() {
    property("border-color", "rgba(255,255,255,0.40)")
    property("box-shadow", "0 0 18px rgba(255,255,255,0.12), 0 0 18px ${UISettings.accentRgba(0.20)}, inset 0 1px 0 rgba(255,255,255,0.14)")
    property("transform", "translateY(1px)")
}

fun StyleScope.applyAppButtonDisabledChrome() {
    backgroundColor(Color.transparent)
    color(UISettings.STATE_BUTTON_TEXT)
    property("border", "1px solid rgba(255,255,255,0.14)")
    property("box-shadow", "0 8px 18px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.05)")
    property("transform", "none")
    cursor("default")
    opacity(0.4)
}

// State-Button: helle Glas-Border, roter Signal-Glow wenn aktiv
fun StyleScope.applyAppStateButtonChrome(isActive: Boolean) {
    backgroundColor(Color.transparent)
    color(UISettings.STATE_BUTTON_TEXT)
    property(
        "border",
        if (isActive) "1px solid rgba(255,255,255,0.30)" else "1px solid rgba(255,255,255,0.14)"
    )
    property(
        "box-shadow",
        if (isActive) "0 12px 30px rgba(0,0,0,0.26), 0 0 18px ${UISettings.accentRgba(0.22)}, inset 0 1px 0 rgba(255,255,255,0.14)" else "0 10px 24px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.07)"
    )
    if (isActive) backgroundColor(rgba(255, 255, 255, 0.06))
    borderRadius(8.px)
    fontSize(12.px)
    fontWeight(if (isActive) "700" else "600")
    cursor("pointer")
    property("box-sizing", "border-box")
    property("transition", "border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease, transform 0.12s ease")
}

fun appStateIconFilter(isActive: Boolean): String {
    return if (isActive) UISettings.STATE_BUTTON_ACTIVE_ICON_FILTER else UISettings.STATE_BUTTON_ICON_FILTER
}
